import Strings from './strings';

export default class LocalizationHelper {
    static readonly isLanguageCs = () => Strings.getLanguage() === 'cs';
    static readonly isLanguageSk = () => Strings.getLanguage() === 'sk';
}
